import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GwcApiConnService } from './gwc-api-conn.service';

@Injectable({
	providedIn: 'root'
})
export class GwcApiOrdersService  {

	constructor(
		private _gwcApiConnService: GwcApiConnService
	) { }


	public uploadQualificationImage(order_id: string, p: { 'content-type': string, image: string}) {
		return this._gwcApiConnService.request('POST', ['Order', order_id, 'qualification', 'image'], undefined, p)
	}

	public getSystemSettings(): Observable<string[]> {
		return this._gwcApiConnService.request('GET', 'SystemSettings') as Observable<string[]>
	}



	// public postCasualOrder(data: any) {
	// 	return this._gwcApiConnService.request('POST', 'CasualOrder', null, data) as Observable<any>
	// }
	
	// public postProcessPayment(casual_order_id: string, payload: any) {
	// 	return this._gwcApiConnService.request('POST', ['CasualOrder', casual_order_id, 'processPayment'], null, payload)
	// }	

	// public postConfirmOrder(casual_order_id: string) {
	// 	return this._gwcApiConnService.request('POST', ['CasualOrder', casual_order_id, 'confirmOrder']);
	// }


}
